// extracted by css-extract-rspack-plugin
export default {"tooltip-container":"Gajb1is0HEZE4cGU","tooltip-top":"GOkVs440rMopQMxz","tooltip-bottom":"Kd0zrTtcsI0bhbJ9","hoverable":"eGD5sa0836EmADGC"};